import { Grid, Switch } from "@mui/material";
import React, { useState } from "react";

export const ProfileSetting = ({ data }: any) => {
  const [checked, setChecked] = useState(data?.is_approve);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Usuario</b>
            <p style={{ marginTop: '8px' }}>{data?.first_name || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Correo</b>
            <p style={{ marginTop: '8px', wordBreak: 'break-all' }}>{data?.email || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>ID de usuario</b>
            <p style={{ marginTop: '8px', wordBreak: 'break-all' }}>{data?.user || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Telefono</b>
            <p style={{ marginTop: '8px' }}>{data?.phone || 'N/A'}</p>
          </div>
        </Grid>
        <Grid item xs={2} sm={4} md={4}>
          <div>
            <b>Fecha de creación</b>
            <p style={{ marginTop: '8px' }}>
              {data?.created_at
                ? new Date(data.created_at).toLocaleDateString("es-MX", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZone: "America/Mexico_City",
                  })
                : 'N/A'}
            </p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
